import React from 'react';
import Loadable from 'react-loadable'

function Loading() {
    return <div className="loading">

    </div>;
}
const Auth = Loadable({
    loader: () => import('./Views/Auth/ForgetPassword/Phonenumber'),
    loading: Loading,
});

// Home
const Home = Loadable({
    loader: () => import('./Views/Home/Home'),
    loading: Loading,
});
//ShowAllServices 
const ShowAllServices = Loadable({
    loader: () => import('./Views/Home/ShowAllServices'),
    loading: Loading,

})
// About Us
const Aboutus = Loadable({
    loader: () => import('./Views/AboutUs/AboutUs'),
    loading: Loading,
});
// Family 
const Family = Loadable({
    loader: () => import('./Views/Family/View/ViewAllMembers'),
    loading: Loading,
});
// View Children 
const ViewChildren = Loadable({
    loader: () => import('./Views/Sons/View/Children'),
    loading: Loading,
});
const EditSon = Loadable({
    loader: () => import('./Views/Sons/Edit/EditSon'),
    loading: Loading,
});
const ViewChildrenDetails = Loadable({
    loader: () => import('./Views/Sons/ViewDetails/viewdetails'),
    loading: Loading,
});
// View Family 
const ViewFamily = Loadable({
    loader: () => import('./Views/Family/View/ViewAllMembers'),
    loading: Loading,
});
const ViewFamilyDetails = Loadable({
    loader: () => import('./Views/Family/ViewDetails/viewdetails'),
    loading: Loading,
});
// View Animals 
const ViewAnimals = Loadable({
    loader: () => import('./Views/Animals/View/ViewAllAnimals'),
    loading: Loading,
});
const ViewAnimalsDetails = Loadable({
    loader: () => import('./Views/Animals/ViewDetails/viewdetails'),
    loading: Loading,
});
// ContactUS 
const ContactUS = Loadable({
    loader: () => import('./Views/ContactUs/ContactUS'),
    loading: Loading,
});

// View Profile 
const ViewProfile = Loadable({
    loader: () => import('./Views/Profile/ViewProfile/ViewProfile'),
    loading: Loading,
});
const EditProfile = Loadable({
    loader: () => import('./Views/Profile/EditProfile/EditProfile'),
    loading: Loading,
});
// View Files 
const ViewFiles = Loadable({
    loader: () => import('./Views/Profile/FilesAttached/ViewFiles'),
    loading: Loading,
});
// prescription View 
const prescriptionView = Loadable({
    loader: () => import('./Views/Profile/FilesAttached/prescriptionView'),
    loading: Loading,
});
// Lab View
const LabView = Loadable({
    loader: () => import('./Views/Profile/FilesAttached/LabView'),
    loading: Loading,
});
// Rays View
const RaysView = Loadable({
    loader: () => import('./Views/Profile/FilesAttached/RaysView'),
    loading: Loading,
});
// Add Data View
const AddDataView = Loadable({
    loader: () => import('./Components/Cards/AddData/AddDataView'),
    loading: Loading,
});
// Add Animal 
const AddAnimal = Loadable({
    loader: () => import('./Views/Animals/Add/AddAnimal'),
    loading: Loading,
});
const EditAnimal = Loadable({
    loader: () => import('./Views/Animals/Edit/EditAnimal'),
    loading: Loading,
});
// Add Children
const AddChildren = Loadable({
    loader: () => import('./Views/Sons/Add/AddSons'),
    loading: Loading,
});
// Add Family Person 
const AddFamilyPerson = Loadable({
    loader: () => import('./Views/Family/Add/AddMember'),
    loading: Loading,
});
const EditFamily = Loadable({
    loader: () => import('./Views/Family/Edit/EditMember'),
    loading: Loading,
});
// Add Lab 
const AddLab = Loadable({
    loader: () => import('./Views/Common/Labs/AddLab'),
    loading: Loading,
});
// Add Rays
const AddRays = Loadable({
    loader: () => import('./Views/Common/Rays/AddRay'),
    loading: Loading,
});
const ViewRays = Loadable({
    loader: () => import('./Views/Common/Rays/ViewRays/ViewRays'),
    loading: Loading,
});
const EditRays = Loadable({
    loader: () => import('./Views/Common/Rays/EditRays/EditRays'),
    loading: Loading,
});

// Add Fortifications
const AddFortifications = Loadable({
    loader: () => import('./Views/Common/Fortifications/AddFortifications'),
    loading: Loading,
});
const ViewFortifications = Loadable({
    loader: () => import('./Views/Common/Fortifications/ViewFortifications/ViewFortifications'),
    loading: Loading,
});
const EditFortifications = Loadable({
    loader: () => import('./Views/Common/Fortifications/EditFortifications/EditFortifications'),
    loading: Loading,
});
//Add Prescription
const AddPrescription = Loadable({
    loader: () => import('./Views/Common/Prescription/AddPrescription'),
    loading: Loading,
})
// Privacy
const Privacy = Loadable({
    loader: () => import('./Views/Privacy/Privacy'),
    loading: Loading,
});
// Rules and Conditions
const RulesandConditions = Loadable({
    loader: () => import('./Views/RulesandConditions/RulesandConditions'),
    loading: Loading,
});

// View Details
const viewDetails = Loadable({
    loader: () => import('./Components/viewDetails/viewDetails'),
    loading: Loading,
});
// View labs for animal , family, childern
const viewLabs = Loadable({
    loader: () => import('./Views/Common/Labs/ViewLabs/viewlabs'),
    loading: Loading,
});
const EditLab = Loadable({
    loader: () => import('./Views/Common/Labs/EditLab/EditLab'),
    loading: Loading,
});

const ViewPrescription = Loadable({
    loader: () => import('./Views/Common/Prescription/viewPrescription/viewPrescription'),
    loading: Loading,
});
const EditPrescription = Loadable({
    loader: () => import('./Views/Common/Prescription/EditPrescription/EditPrescription'),
    loading: Loading,
});
// Notification
const Notification = Loadable({
    loader: () => import('./Views/Notifications/Notification'),
    loading: Loading,
});

const routes = [
    // Home
    { path: `/HealthBook-Web/Home`, exact: true, name: 'Home', component: Home },
    //ShowAllServices
    { path: `/HealthBook-Web/ShowAllServices`, exact: true, name: 'ShowAllServices', component: ShowAllServices },
    // About us
    { path: `/HealthBook-Web/about-us`, exact: true, name: 'About us', component: Aboutus },
    // Family
    { path: `/HealthBook-Web/family`, exact: true, name: 'family', component: Family },
    // View Children
    { path: `/HealthBook-Web/ViewChildren`, exact: true, name: 'View Children', component: ViewChildren },
    { path: `/HealthBook-Web/ViewChildrenDetails`, exact: true, name: 'ViewChildrenDetails', component: ViewChildrenDetails },
    { path: `/HealthBook-Web/EditSon`, exact: true, name: "EditSon", component: EditSon },
    // View Family
    { path: `/HealthBook-Web/ViewFamily`, exact: true, name: 'View Family', component: ViewFamily },
    { path: `/HealthBook-Web/ViewFamily-Details`, exact: true, name: 'View Details Family', component: ViewFamilyDetails },
    // View Animals
    { path: `/HealthBook-Web/ViewAnimals`, exact: true, name: 'View Animals', component: ViewAnimals },
    { path: `/HealthBook-Web/ViewAnimals-Details`, exact: true, name: 'View Details Animals', component: ViewAnimalsDetails },
    // contact-us
    { path: `/HealthBook-Web/contact-us`, exact: true, name: 'contact-us', component: ContactUS },
    // Profile
    { path: `/HealthBook-Web/Profile`, exact: true, name: 'ViewProfile', component: ViewProfile },
    { path: `/HealthBook-Web/edit-Profile`, exact: true, name: 'Edit Profile', component: EditProfile },
    // Profile Files
    { path: `/HealthBook-Web/ProfileFiles`, exact: true, name: 'Profile Files', component: ViewFiles },
    // prescriptionView
    { path: `/HealthBook-Web/prescriptionView`, exact: true, name: 'prescriptionView', component: prescriptionView },
    //LabView
    { path: `/HealthBook-Web/LabView`, exact: true, name: 'Lab View', component: LabView },
    // Rays View
    { path: `/HealthBook-Web/RaysView`, exact: true, name: 'RaysView', component: RaysView },
    // Add DataView
    { path: `/HealthBook-Web/AddDataView`, exact: true, name: 'AddDataView', component: AddDataView },
    // Add Animal
    { path: `/HealthBook-Web/AddAnimal`, exact: true, name: 'AddAnimal', component: AddAnimal },
    { path: `/HealthBook-Web/EditAnimal`, exact: true, name: "EditAnimal", component: EditAnimal },
    // AddChildren
    { path: `/HealthBook-Web/AddChildren`, exact: true, name: 'Add Children', component: AddChildren },
    // Add Family Person
    { path: `/HealthBook-Web/AddFamilyPerson`, exact: true, name: 'AddFamilyPerson', component: AddFamilyPerson },
    { path: `/HealthBook-Web/EditFamily`, exact: true, name: "EditFamily", component: EditFamily },
    // Add Lab
    { path: `/HealthBook-Web/AddLab`, exact: true, name: 'AddLab', component: AddLab },
    // Add Rays
    { path: `/HealthBook-Web/AddRays`, exact: true, name: 'AddRays', component: AddRays },
    { path: `/HealthBook-Web/ViewRays`, exact: true, name: 'ViewRays', component: ViewRays },
    { path: '/HealthBook-Web/EditRays', exact: true, name: 'EditRays', component: EditRays },
    // Add Fortifications
    { path: `/HealthBook-Web/AddFortifications`, exact: true, name: 'contact-us', component: AddFortifications },
    { path: `/HealthBook-Web/ViewFortifications`, exact: true, name: 'ViewFortifications', component: ViewFortifications },
    { path: `/HealthBook-Web/EditFortifications`, exact: true, name: 'EditFortifications', component: EditFortifications },
    // Add Prescription
    { path: `/HealthBook-Web/AddPrescription`, exact: true, name: 'AddPrescription', component: AddPrescription },
    // Privacy
    { path: `/HealthBook-Web/Privacy`, exact: true, name: 'Privacy', component: Privacy },
    // Rules and Conditions
    { path: `/HealthBook-Web/RulesandConditions`, exact: true, name: 'Rules and Conditions', component: RulesandConditions },
    // View Details
    { path: `/HealthBook-Web/viewDetails`, exact: true, name: 'viewDetails', component: viewDetails },


    { path: `/HealthBook-Web/Auth`, exact: true, name: 'Auth', component: Auth },

    { path: `/HealthBook-Web/viewLabs`, exact: true, name: 'viewLabs', component: viewLabs },
    { path: `/HealthBook-Web/EditLab`, exact: true, name: 'EditLab', component: EditLab },
    { path: `/HealthBook-Web/ViewPrescription`, exact: true, name: 'ViewPrescription', component: ViewPrescription },
    { path: `/HealthBook-Web/EditPrescription`, exact: true, name: 'EditPrescription', component: EditPrescription },
    //Notification
    { path: `/HealthBook-Web/Notifications`, exact: true, name: 'Notification', component: Notification }
]

export default routes;